import React, { useContext, useMemo } from "react";
import Flex from "Trackalyze/Flex";
import { FilteredTracksContext } from "~/Context/FilteredTracksContext";
import { ImportContext } from "~/Context/ImportContext";
import Typo from "Trackalyze/Typo";
import { useTranslation } from "react-i18next";
import Switch from "Trackalyze/Switch";
import { ListItem } from "Trackalyze/List";

const FilterFavorites = (props) => {
  const { t } = useTranslation();

  const {
    filterFavorites,
    setFilterFavorites,
    filterActivities,
    filterWaypoints,
    filterGpxTypes,
    filterGroups,
    handleFilterTracks,
    searchQuery,
  } = useContext(FilteredTracksContext);
  const { tracksIndex } = useContext(ImportContext);

  const isSelected = filterFavorites.includes("isFavorite");

  const handleSwitch = (val) => {
    setFilterFavorites((prev) => {
      if (val) {
        if (!prev.includes("isFavorite")) return [...prev, "isFavorite"];
        return prev;
      } else {
        return prev.filter((id) => id !== "isFavorite");
      }
    });
  };

  // Calculate tracks filtered by others to show available count
  const tracksFilteredByOthers = useMemo(() => {
    return handleFilterTracks(
      tracksIndex,
      filterActivities,
      filterWaypoints,
      [], // Exclude current
      filterGpxTypes,
      filterGroups,
      searchQuery,
    );
  }, [
    tracksIndex,
    filterActivities,
    filterWaypoints,
    filterGpxTypes,
    filterGroups,
    handleFilterTracks,
    searchQuery,
  ]);

  const favoritesCount = useMemo(() => {
    return tracksFilteredByOthers.filter(
      (t) => t["info.favorite"] === true || t["info.favorite"] === "true",
    ).length;
  }, [tracksFilteredByOthers]);

  if (!props.standalone && favoritesCount === 0 && !isSelected) return null;

  return (
    <ListItem>
      <Flex vertical spacing="3" padding="s">
        <Flex spacing="3" out itemscenter>
          <Flex spacing="2" itemscenter>
            <Typo type="label" size="l">
              {t("trackManager.filterFavorites")}
            </Typo>
            <Typo
              type="label"
              size="l"
              className="ta-color-text_on-surface-lower"
            >
              {favoritesCount}
            </Typo>
          </Flex>
          <Switch switched={isSelected} callBack={handleSwitch} />
        </Flex>
      </Flex>
    </ListItem>
  );
};

export default React.memo(FilterFavorites);
